import React from 'react';
import NeedsAttentionMessage from './NeedsAttentionMessage';
import InlineLoader from '../../components/loader/InlineLoader';

const Message = ({ message, onResolveAttention, onRevokeAttention }) => {
  // Extract data from the API response
  const {
    message: text,
    created_on: timestamp,
    selfSender,
    msg_type,
    first_name,
    last_name,
    attention_completion_status,
    isOptimistic, 
    failed, 
    message_id
  } = message;

  // Format time from created_on
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  // Show needs attention message if the type is 'needs_attention'
  if (msg_type === 'needs_attention') {
    return (
      <NeedsAttentionMessage 
        time={formatTime(timestamp)} 
        sent={selfSender}
        isResolved={attention_completion_status !== null}
        status={attention_completion_status}
        message={text}
        isOptimistic={isOptimistic}
        failed={failed}
        messageId={message_id}
        onResolve={onResolveAttention}
        onRevoke={onRevokeAttention}
      />
    );
  }

  return (
    <div 
      className={`
        ${selfSender
          ? 'self-end bg-primary text-primary-foreground' 
          : 'self-start bg-white'
        }
        p-3 px-4 rounded-lg max-w-[70%] relative shadow-sm
        ${isOptimistic ? 'opacity-70' : ''}
        ${failed ? 'border-red-500 border' : ''}
      `}
    >
      <p className="text-sm">
        {text}
        {isOptimistic && (
          <span className="ml-2 inline-flex items-center">
            <InlineLoader className="w-3 h-3 text-gray-400" />
          </span>
        )}
        {failed && <span className="ml-2 text-xs text-red-500">Failed to send</span>}
      </p>
      <p className={`text-xs ${selfSender ? 'text-primary-foreground/80' : 'text-gray-500'} text-right mt-1`}>
        {formatTime(timestamp)}
      </p>
    </div>
  );
};

export default Message;
